export default "__VITE_ASSET__wTKDp$eT__"